/* GASSISA
=========================================================================================
* Descripción: Actions del módulo de Administración de Nóminas
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 07/08/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 08/08/2026 | Lic. José Luis Aragón Cervantes  | Se agregan botones Nueva, Aplicar e Imprimir resumen; Guardar/Editar
*      3       | 08/08/2026 | Lic. José Luis Aragón Cervantes  | Se agregan botones Calcular e Historial
*      4       | 10/08/2026 | Lic. José Luis Aragón Cervantes  | Agrega impresión masiva de recibos por PrinterTools
*      5       | 10/08/2026 | Lic. José Luis Aragón Cervantes  | Ajusta texto visible de impresión de ticket
*      6       | 10/08/2026 | Lic. José Luis Aragón Cervantes  | Simplifica texto de guardado de nómina
 *      7       | 10/08/2026 | Lic. José Luis Aragón Cervantes  | Agrega acceso de búsqueda de nóminas
 *      8       | 19/08/2026 | Lic. José Luis Aragón Cervantes  | Agrega Eliminar nómina actual en Otras acciones
 * ---------------------------------------------------------------------------------------
*/

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CheckIcon from "@mui/icons-material/Check";
import CalculateIcon from "@mui/icons-material/Calculate";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PrintIcon from "@mui/icons-material/Print";
import PaymentsIcon from "@mui/icons-material/Payments";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";
import MnuDangerActionsMenu from "../utils/MnuDangerActionsMenu";

export default function MnuNominasActions({
    onSalir,
    onNueva,
    onCalcular,
    onGuardar,
    onAplicar,
    onHistorial,
    onBuscarNominas,
    onImprimirResumen,
    onImprimirRecibos,
    onPrestamos,
    onEliminar,
    eliminarDisabled = true,
    cargando = false,
    editable = true,
}) {
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
    const buscarNominas = onBuscarNominas || onHistorial;

    return (
        <Fragment>
            <Tooltip title={"Salir"}>
                <IconButton onClick={onSalir}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </Tooltip>
            {onCalcular && (
                <Tooltip title={"Calcular la nómina del periodo programado"}>
                    <IconButton
                        onClick={() => executeWithProtection(onCalcular)}
                        disabled={isProcessing || cargando}
                    >
                        <CalculateIcon className="icon" /><p className="icon"> Calcular</p>
                    </IconButton>
                </Tooltip>
            )}
            {onNueva && (
                <Tooltip title={"Empezar una nómina nueva con el siguiente folio disponible"}>
                    <IconButton
                        onClick={() => executeWithProtection(onNueva)}
                        disabled={isProcessing || cargando}
                    >
                        <AddIcon className="icon" /><p className="icon"> Nueva</p>
                    </IconButton>
                </Tooltip>
            )}
            {onGuardar && editable && (
                <Tooltip title={"Guardar o editar la nómina en proceso"}>
                    <IconButton
                        onClick={() => executeWithProtection(onGuardar)}
                        disabled={isProcessing || cargando}
                    >
                        <SaveIcon className="icon" /><p className="icon"> Guardar</p>
                    </IconButton>
                </Tooltip>
            )}
            {onAplicar && editable && (
                <Tooltip title={"Aplicar la nómina: cambia el estatus a TERMINADA y ya no será editable"}>
                    <IconButton
                        onClick={() => executeWithProtection(onAplicar)}
                        disabled={isProcessing || cargando}
                    >
                        <CheckIcon className="icon" /><p className="icon"> Aplicar</p>
                    </IconButton>
                </Tooltip>
            )}
            {buscarNominas && (
                <Tooltip title={"Buscar nóminas guardadas (Alt+F2)"}>
                    <IconButton
                        onClick={() => executeWithProtection(buscarNominas)}
                        disabled={isProcessing || cargando}
                    >
                        <SearchIcon className="icon" /><p className="icon"> Buscar</p>
                    </IconButton>
                </Tooltip>
            )}
            {onPrestamos && (
                <Tooltip title={"Préstamos a empleados"}>
                    <IconButton
                        onClick={() => executeWithProtection(onPrestamos)}
                        disabled={isProcessing || cargando}
                    >
                        <PaymentsIcon className="icon" /><p className="icon"> Préstamos</p>
                    </IconButton>
                </Tooltip>
            )}
            {onImprimirRecibos && (
                <Tooltip title={"Imprimir todos los recibos de nómina"}>
                    <IconButton
                        onClick={() => executeWithProtection(onImprimirRecibos)}
                        disabled={isProcessing || cargando}
                    >
                        <PrintIcon className="icon" /><p className="icon"> Recibos</p>
                    </IconButton>
                </Tooltip>
            )}
            {onImprimirResumen && (
                <Tooltip title={"Generar el reporte general de nómina en PDF con el detalle y totales"}>
                    <IconButton
                        onClick={() => executeWithProtection(onImprimirResumen)}
                        disabled={isProcessing}
                    >
                        <PictureAsPdfIcon className="icon" /><p className="icon"> Imprimir PDF</p>
                    </IconButton>
                </Tooltip>
            )}
            {onEliminar && (
                <MnuDangerActionsMenu
                    tooltip="Otras acciones"
                    actions={[
                        {
                            label: "Eliminar nómina actual",
                            onClick: onEliminar,
                            disabled: eliminarDisabled,
                        },
                    ]}
                />
            )}
        </Fragment>
    );
}